module.exports = __webpack_public_path__ + "static/media/LikeGreenActive.b18e69c2.svg";